/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import { Outlet } from 'react-router-dom'
import SideNavBar from './Sidebar';
import {  useSelector } from 'react-redux';

export default function Layout() {
    const auth = useSelector(state => state?.auth);
    const {userType} = auth
    // const SideBar = useMemo(() => <SideBar role={userType} />, []);
    return (
        <>
            <div className="flex h-screen overflow-x-hidden">
                <SideNavBar role={userType}/>
                <Outlet />
            </div>
           
        </>
        
    )
}
